/* eslint-disable max-lines */
import $ from 'jquery';
import events from './events.js';
import page from '../../smartpak/page.js';
import {parseQueryString} from '../../smartpak/url.js';

const HIDE_CLASS = 'w-js-hide',
    paging = {
        jsStyles: function() {
            if (/\/horse-supplement-wizard\/lifeStyle/gi.test(location.pathname)) {
                $('#w-submitCon, .wizard-header-actions')
                    .find('a, button')
                    .removeClass(HIDE_CLASS);
            }

            function markAsAnswered($question) {
                $question.addClass('is-answered');
            }

            function markAsUnanswered($question) {
                $question.removeClass('is-answered');
            }

            $('.w-question').each(function(i, item) {
                var $question = $(item),
                    $select,
                    $input;

                $question.find('select').on('change', function(e) {
                    $select = $(e.target);

                    if ($select.children('option:selected').val().length && !$question.hasClass('is-answered')) {
                        markAsAnswered($question);
                    } else if (!$select.children('option:selected').val().length) {
                        markAsUnanswered($question);
                    }
                });

                $question.find('input[type="radio"], input[type="checkbox"]').on('change', function(e) {
                    $input = $(e.target);

                    if (!$question.hasClass('is-answered')) {
                        markAsAnswered($question);
                    } else if (
                        $input.attr('type') != 'radio' &&
                        !$question.find('input[type="checkbox"]:checked').length
                    ) {
                        markAsUnanswered($question);
                    }

                    if ($input.attr('type') === 'checkbox' && $input.attr('id') === '8203') {
                        if ($input.is(':checked')) {
                            $question
                                .find('input[type="checkbox"]:checked')
                                .not($input)
                                .prop('checked', false);
                        }
                    } else if ($input.attr('type') === 'checkbox') {
                        if ($input.is(':checked')) {
                            $('#8203').prop('checked', false);
                        }
                    }
                });
            });

            $('select').each(function(i, item) {
                var $select = $(item);
                if ($select.find('option:selected').val().length > 0) {
                    $select.closest('.w-question').addClass('is-answered');
                }
            });

            $(document)
                .find('.question-row, .question-column')
                .each(function(i, item) {
                    var $item = $(item);
                    if ($item.find('input[type="radio"]:checked, input[type="checkbox"]:checked').length) {
                        markAsAnswered($item.closest('.w-question'));
                    }
                });
        },
        buildSubpages: function() {
            var container = this._$questionList.get(0),
                subpageWrapper = document.createElement('div'),
                key;

            subpageWrapper.setAttribute('id', 'wizard-subpages');
            subpageWrapper.setAttribute('class', 'subpages');
            container.appendChild(subpageWrapper);

            function questionIterator(page) {
                for (key in page) {
                    if (Object.prototype.hasOwnProperty.call(page, key)) {
                        var current = page[key],
                            thisPage = document.createElement('div');
                        thisPage.setAttribute('class', 'wizard-subpage');
                        thisPage.setAttribute('data-title', current.title);
                        thisPage.setAttribute('data-questions', current.questions);
                        subpageWrapper.appendChild(thisPage);
                    }
                }
            }

            for (key in window.wizardSubpages) {
                if (Object.prototype.hasOwnProperty.call(window.wizardSubpages, key)) {
                    questionIterator(window.wizardSubpages[key]);
                }
            }
        },
        pluralize: function(name) {
            var horseName = name,
                lastChar = horseName[horseName.length - 1];

            if (lastChar !== 's') {
                horseName = horseName + "'s";
            } else {
                horseName = horseName + "'";
            }

            return horseName;
        },
        divideSubpageContent: function() {
            this.buildSubpages();

            var horseName = paging.pluralize(window.wizardSubpages.horseName());

            this._$questionList.find('.wizard-subpage').each(function(index, element) {
                var $element = $(element),
                    title = $element.data('title'),
                    questions = $element
                        .data('questions')
                        .split(',')
                        .map(function(question) {
                            return question.replace(' ', '');
                        });

                $element.append(buildSubPageHeaderHTML(horseName, title));

                questions.forEach(function(question) {
                    $element.append($('#' + question));
                });
            });

            $('.w-category').remove();

            this.subpageNavigation();
            this._setPageCount();
            this._navigateTo(this._current);
        },
        _checkForFirst: function(isFirst) {
            if (isFirst) {
                this._$form.find('.previous').addClass(HIDE_CLASS);
                this._$form.find('.go-back-event:not(.previous)').removeClass(HIDE_CLASS);
            } else {
                this._$form.find('.go-back-event:not(.previous)').addClass(HIDE_CLASS);
                this._$form.find('.previous').removeClass(HIDE_CLASS);
            }
        },
        _checkForLast: function(isLast) {
            if (isLast) {
                this._$form.find('.next').addClass(HIDE_CLASS);
                this._$form.find('.wizard-submit-button').removeClass(HIDE_CLASS);
            } else {
                this._$form.find('.next').removeClass(HIDE_CLASS);
                this._$form.find('.wizard-submit-button').addClass(HIDE_CLASS);
            }
        },
        _changePage: function(page) {
            var $pages = $('#wizard-subpages .wizard-subpage'),
                VISIBLE = 'is-visible';

            if ($pages.eq(page).length) {
                $pages.filter('.' + VISIBLE).removeClass(VISIBLE);
                $pages.eq(page).addClass(VISIBLE);

                this._current = page;

                this._checkForFirst(this._current === 0);
                this._checkForLast(this._current === $pages.length - 1);
            } else if (page === -1) {
                window.location.href = '/horse-supplement-wizard/lifeStyle/';
            }
        },
        _navigateTo: function(destination) {
            this._changePage(destination);
            this._setCurrentPage(destination);

            if (page.isMobile()) {
                window.scrollTo(0, 0);
            }
        },
        subpageNavigation: function() {
            $('#wizard-container')
                .on(
                    'click',
                    '.previous',
                    function(e) {
                        e.preventDefault();

                        this.hideErrorText();
                        this._navigateTo(this._current - 1);
                    }.bind(this)
                )
                .on(
                    'click',
                    '.next',
                    function(e) {
                        e.preventDefault();
                        this.hideErrorText();
                        if (this.subpageValiation(this._current)) {
                            this._navigateTo(this._current + 1);
                        }
                    }.bind(this)
                );
        },
        hideErrorText: function() {
            var questions = $('.w-question'),
                errorBlock = $('.w-validation-error'),
                list = errorBlock.find('ul');

            questions.removeClass('w-alert-con');
            errorBlock.addClass(HIDE_CLASS);
            errorBlock.find('.validation-summary-errors').removeClass('validation-summary-errors');
            list.empty();
        },
        _setPageCount: function() {
            $('.page-total').text($('.wizard-subpage').length);
        },
        _setCurrentPage: function(num) {
            $('.page-count').text(num + 1);
        },
        subpageValiation: function(current) {
            var subpages = $('.wizard-subpage'),
                questions = $(subpages[current]).find('.w-question'),
                errorBlock = $('.w-validation-error'),
                list = errorBlock.find('ul'),
                incomplete = 0,
                i,
                q,
                s,
                selects,
                radios,
                checkboxes;

            function showErrorText(questionText) {
                list.append('<li>' + questionText + '</li>');

                errorBlock.find('.validation-summary-valid').addClass('validation-summary-errors');
                errorBlock.removeClass(HIDE_CLASS);
            }

            function checkRadiosAndCheckboxes(answers, question) {
                if (answers.length) {
                    for (var r = 0; r < answers.length; r++) {
                        if ($(answers[r]).is(':checked')) {
                            return true;
                        }
                    }

                    question.addClass('w-alert-con');
                    showErrorText(question.children('.w-question-title').text());
                    incomplete++;
                }

                return false;
            }

            this.hideErrorText();

            for (i = 0; i < questions.length; i++) {
                q = $(questions[i]);
                selects = q.find('select');
                radios = q.find('input[type="radio"]');
                checkboxes = q.find('input[type="checkbox"]');

                for (s = 0; s < selects.length; s++) {
                    if ($(selects[s]).val().length === 0) {
                        q.addClass('w-alert-con');
                        showErrorText(q.children('.w-question-title').text());

                        incomplete++;
                    }
                }

                checkRadiosAndCheckboxes(radios, q);
                checkRadiosAndCheckboxes(checkboxes, q);
            }

            if (incomplete === 0) {
                this.hideErrorText();
                return true;
            }
            return false;
        },
        init: function() {
            var startOnPage = parseQueryString(location.search).page;

            this._$questionList = $('#supplement-wizard-question-list');
            this._$form = $('#wizard-container > form');
            this._current = startOnPage ? +startOnPage - 1 : 0;
            this.jsStyles();

            this._$form.on(
                'submit',
                function(e) {
                    if (!this.subpageValiation(this._current)) {
                        e.preventDefault();
                        $('.progress-indicator').hide();
                        this._$form.find('[type=submit]').prop('disabled', false);
                    }
                }.bind(this)
            );

            if (this._$questionList.length) {
                this.divideSubpageContent();
                events.addHealthEventListeners();
            } else {
                events.addLifeStyleEventListeners();
            }
        }
    };

export default paging;

function buildSubPageHeaderHTML(horseName, title) {
    return (
        '<div class="wizard-subheading-container">' +
        '<div class="wizard-recommendations-header wizard-recommendations-header-container globalWidth container">' +
        '<div class="wizard-header-text">' +
        '<h2 class="wizard-animal-name">' +
        horseName +
        ' ' +
        title +
        '</h2>' +
        '<div class="wizard-header-section">Section <span class="page-count"></span>/<span class="page-total"></span></div>' +
        '</div>' +
        '<div class="wizard-header-actions">' +

        '<a href="/horse-supplement-wizard/lifestyle" class="w-js-hide health-exit-link go-back-event secondary button" data-icon="left">' +
        'Go Back' +
        '<span class="icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path d="M231.293 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L70.393 256 251.092 74.87c4.686-4.686 4.686-12.284 0-16.971L231.293 38.1c-4.686-4.686-12.284-4.686-16.971 0L4.908 247.515c-4.686 4.686-4.686 12.284 0 16.971L214.322 473.9c4.687 4.686 12.285 4.686 16.971-.001z"></path></svg></span>' +
        '</a>' +

        '<button class="previous go-back-event secondary button" data-icon="left">' +
        'Go Back' +
        '<span class="icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path d="M231.293 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L70.393 256 251.092 74.87c4.686-4.686 4.686-12.284 0-16.971L231.293 38.1c-4.686-4.686-12.284-4.686-16.971 0L4.908 247.515c-4.686 4.686-4.686 12.284 0 16.971L214.322 473.9c4.687 4.686 12.285 4.686 16.971-.001z"></path></svg></span>' +
        '</button>' +

        '<button type="submit" class="next wizard-submit-button w-js-hide primary button" data-icon="right">' +
        'Continue' +
        '<span class="icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path d="M24.707 38.101L4.908 57.899c-4.686 4.686-4.686 12.284 0 16.971L185.607 256 4.908 437.13c-4.686 4.686-4.686 12.284 0 16.971L24.707 473.9c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L41.678 38.101c-4.687-4.687-12.285-4.687-16.971 0z"></path></svg></span>' +
        '</button>' +

        '<button class="next primary button" data-icon="right">' +
        'Continue' +
        '<span class="icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"><path d="M24.707 38.101L4.908 57.899c-4.686 4.686-4.686 12.284 0 16.971L185.607 256 4.908 437.13c-4.686 4.686-4.686 12.284 0 16.971L24.707 473.9c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L41.678 38.101c-4.687-4.687-12.285-4.687-16.971 0z"></path></svg></span>' +
        '</button>' +

        '</div>' +
        '</div>' +
        '</div>'
    );
}
